import mixpanel from 'mixpanel-browser';
import { useEffect } from 'react';

function useTrackPageView(page: string, extras: Record<string, unknown> | null = null): void {
  const dependencies = Object.values(extras || {});
  useEffect(() => {
    mixpanel.track(`View ${page} page`, extras);
  }, [page, ...dependencies]);
}

export default useTrackPageView;
